import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import api from '../seller-apis/api';
import { allOrdersWeb, cancelledOrders, revokedOnly, inTransitOrders, deliveredOrders, unverifiedPriceProducts, filterOrdersfilter, orderRevoke, fetchOpportunityData, filterOrders } from '../seller-apis/apidataField';
import './order.css';
import { useAlert } from 'react-alert';
import { Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import AllOrders from './OrderComponents/AllOrders';
import CancelledOrders from './OrderComponents/Cancelled';
import Revoked from './OrderComponents/Revoked/Revoked';
import DeliveredOrders from './OrderComponents/Delivered'
import InTransitOrders from './OrderComponents/InTransit';
import ProcessedOrders from './OrderComponents/Processed';
import RedispatchOrders from './OrderComponents/Redispatch';
import UnProcessedOrders from './OrderComponents/UnProcessed';
import RevokeOnly from './OrderComponents/RevokeOnly';
import { Actions } from '../Actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import OrdersTabs from './OrderComponents/OrdersTab';
import ProductOpportunities from './OrderComponents/ProductOpportunities';
import GrabOrders from './OrderComponents/GrabOrders';
import moment from 'moment';
import ReverseOrders from './OrderComponents/ReverseOrders';
import PickupRequest from './OrderComponents/PickupRequest';

let orderCountsBulkInflight = null;

function Order() {
  const alert = useAlert()

  const [allRecords, setallRecords] = useState();
  const [allPriceVerified, setallPriceVerified] = useState(true)

  // Records for different orders status
  const [revokedRec, setrevokedRec] = useState();
  const [cancelledRec, setcancelledRec] = useState();
  const [processedRec, setprocessedRec] = useState();
  const [unprocessedRec, setunprocessedRec] = useState();
  const [deliveredRec, setdeliveredRec] = useState();
  const [intransitRec, setintransitRec] = useState();
  const [rtoRec, setrtoRec] = useState();
  const { path, url } = useRouteMatch()
  const dispatch = useDispatch();
  const orderCountsBulkFetchCompleted = useSelector(
    (state) => state.ActionReducer.orderCountsBulkFetchCompleted
  );

  useEffect(() => {
    if (orderCountsBulkFetchCompleted) {
      return;
    }
    if (!orderCountsBulkInflight) {
      orderCountsBulkInflight = (async () => {
        const filterData = {
          pageNo: 1,
          size: 1,
        };

        const grabOrderFilter = {
          pageNo: 1,
          size: 1,
          filters: {
            status: "pending",
            orderType: "grab_order",
          },
          sortFilter: { createdAt: -1 },
        };

        const fromNewOrder = moment().subtract(30, "days").format("YYYY-MM-DD");
        const toNewOrder = moment().format("YYYY-MM-DD");
        const newOrdersFilter = filterOrdersfilter(filterData, ["ASSIGN"]);
        const readyToShipFilter = filterOrdersfilter(filterData,["DOWNLOAD"])
        const pickupRequestFilter = filterOrdersfilter(filterData, ["Pickup Pending"])
        newOrdersFilter.filter["from-createdAt"] = fromNewOrder + "T00:00:00";
        newOrdersFilter.filter["to-createdAt"] = toNewOrder + "T23:59:59";
        readyToShipFilter.filter["from-createdAt"] = fromNewOrder + "T00:00:00";
        readyToShipFilter.filter["to-createdAt"] = toNewOrder + "T23:59:59";
        pickupRequestFilter.filter["from-createdAt"] = fromNewOrder + "T00:00:00";
        pickupRequestFilter.filter["to-createdAt"] = toNewOrder + "T23:59:59";
        const currentDate = new Date();
        const before59Days = new Date();
        before59Days.setDate(currentDate.getDate() - 59);
        const currentDateStr = currentDate.toISOString().split("T")[0];
        const before59DaysStr = before59Days.toISOString().split("T")[0];

        const globalFilterredis = {
          pageNo: 1,
          size: 1,
          filter: {
            "from-createdAt": before59DaysStr + "T00:00:00",
            "to-createdAt": currentDateStr + "T23:59:59",
            redispatchOrder: "Yes",
            "redispatchData.redispatch.pkgs.docketStatus": "Pickup Pending",
          },
          sortFilter: {
            ticketId: -1,
          },
        };

        const globalFilterReverse = {
          pageNo: 1,
          size: 1,
          filter: {
            "from-createdAt": before59DaysStr + "T00:00:00",
            "to-createdAt": currentDateStr + "T23:59:59",
            reverseOrder: "Yes",
          },
          sortFilter: {
            ticketId: -1,
          },
        };

        const addressBody = {
          filter: {},
          excludeField: {},
          pageNo: 1,
          sortFilter: {},
        };

        const tasks = [
          api.Opportunity.fetchOpportunity(fetchOpportunityData(grabOrderFilter)).then((res) => {
            Actions.GrabOrderCountAction(dispatch, res.totalRecords);
            Actions.OrderCountAction(dispatch, { grabOrders: res.totalRecords });
          }),
          api.order.orders(orderRevoke(filterData)).then((res) => {
            Actions.OrderCountAction(dispatch, { revoked: res.totalRecords });
          }),
          api.order.orders(newOrdersFilter).then((res) => {
            console.log("New Orders", res.totalRecords);
            setunprocessedRec(res.totalRecords);
            Actions.OrderCountAction(dispatch, { newOrders: res.totalRecords });
          }),
          api.order.orders(pickupRequestFilter).then((res) => {
            Actions.OrderCountAction(dispatch, { pickupRequest: res.totalRecords });
          }).catch(err => {
            console.log(err)
          }),
          api.order.orders(readyToShipFilter).then((res) => {
            setprocessedRec(res.totalRecords);
            Actions.OrderCountAction(dispatch, { readyToShipped: res.totalRecords });
          }),
          api.order.getReverseOrder(globalFilterReverse).then((res) => {
            Actions.OrderCountAction(dispatch, { reverseOrder: res.totalRecords });
          }),
          api.order.getRedispatchOrder(globalFilterredis).then((res) => {
            Actions.OrderCountAction(dispatch, { Redispatch: res.totalRecords });
          }),
          api.order.orders(allOrdersWeb(filterData)).then((res) => {
            setallRecords(res.totalRecords);
            Actions.OrderCountAction(dispatch, { all: res.totalRecords });
          }),
          api.seller.getSellerAddress(addressBody).then((res) => {
            Actions.updateSellerAddress(dispatch, { data: res.data });
          }),
        ];

        const results = await Promise.allSettled(tasks);
        results.forEach((r) => {
          if (r.status === "rejected") {
            console.log(r.reason);
          }
        });
      })().finally(() => {
        orderCountsBulkInflight = null;
        Actions.orderCountsBulkFetchComplete(dispatch);
      });
    }
  }, [dispatch, orderCountsBulkFetchCompleted]);


  useEffect(() => {
    if (allRecords < 1) {
      alert.show('No Orders Found', {
        "type": "info",
        "timeout": "7000"
      })
    }
  }, [allRecords])



    return (
      <>

        <div className="">
          <div className='filter_options order_nav_cntn d-flex tab text-center'>
            {/* <div className='ord_table order_nav_div' style={{ width: "100%" }}>
              <NavLink exact to={`${path}/revoke`} className="order_nav"><button className='filter_options_btn me-2'>Revoked ({revokedRec})
              <OverlayTrigger
                  key="revord"
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-revord`} className="fs-10 order_page_tooltip">
                      <p className='fs-15 f-500 order_page_tooltip_1'> These orders are revoked (cancelled), please do not paste these manifests on any package.</p>
                    </Tooltip>
                  }
                >
                  <i class="bi bi-info-circle ms-1"></i>
                </OverlayTrigger>
              </button></NavLink>
              <NavLink exact to={`${path}/unprocessed`} className="order_nav"><button className='filter_options_btn me-2'>Unprocessed ({unprocessedRec})</button></NavLink>
              <NavLink exact to={`${path}/processed`} className="order_nav"><button className='filter_options_btn me-2'>Processed ({processedRec})</button></NavLink>
              <NavLink exact to={`${url}/inTransit`} className="order_nav"><button className='filter_options_btn me-2'>In-Transit ({intransitRec})</button></NavLink>
              <NavLink exact to={`${url}/cancelled`} className="order_nav"><button className='filter_options_btn me-2'>Cancelled ({cancelledRec})</button></NavLink>
              <NavLink to={`${url}/rto`} className="order_nav"><button className='filter_options_btn me-2'>RTO ({rtoRec})</button></NavLink>
              <NavLink exact to={`${url}/delivered`} className="order_nav"><button className='filter_options_btn me-2'>Delivered ({deliveredRec})</button></NavLink>
              <NavLink exact to={`${url}/allOrders`} className="order_nav"><button className='filter_options_btn me-2'>All Orders ({allRecords})
                <OverlayTrigger
                  key="allord"
                  placement="bottom"
                  overlay={
                    <Tooltip id={`tooltip-allord`} className="fs-10 order_page_tooltip">
                      <p className='fs-15 f-500 order_page_tooltip_1'>excluding RTO Orders</p>
                    </Tooltip>
                  }
                >
                  <i class="bi bi-info-circle ms-1"></i>
                </OverlayTrigger>
              </button></NavLink>
            </div> */}
          </div>
        </div>
        <OrdersTabs />
        <div>
          <Route exact path="/my-order">
            <Redirect to={`${path}/revoke`} />
          </Route>
          <Route path={`${path}/revoke`} component={RevokeOnly} />
          <Route path={`${path}/processed`} component={ProcessedOrders} />
          <Route path={`${path}/redispatch`} component={RedispatchOrders} />
          <Route path={`${path}/unprocessed`} component={UnProcessedOrders} />
          <Route path={`${path}/pickup-request`} component={PickupRequest} />
          <Route path={`${path}/inTransit`} component={InTransitOrders} />
          <Route path={`${path}/delivered`} component={DeliveredOrders} />
          <Route path={`${path}/allOrders`} component={AllOrders} />
          <Route path={`${path}/cancelled`} component={CancelledOrders} />
          <Route path={`${path}/rto`} component={Revoked} />
          <Route path={`${path}/graborder`} component={GrabOrders} />
          <Route path={`${path}/reverse`} component={ReverseOrders} />
        </div>
      </>
    )
}


export default Order;